import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap"

import { useSelector } from "react-redux"

import { useDispatch } from "react-redux"
import { withTranslation } from "react-i18next"

const ExtrasDropdown = props => {
  const layoutMode = useSelector(state => state.Layout.layoutMode)
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const userData = useSelector(state => state.Login.userData)
  const dispatch = useDispatch()

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <i
            className="mdi mdi-help-circle-outline"
            style={{ fontSize: "25px" }}
          ></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem tag="a" href="/profile">
              {" "}
              <i className="mdi mdi-account-circle font-size-17 text-muted align-middle me-1" />
              {props.t("Profile")}{" "}
            </DropdownItem> */}
          {/* <DropdownItem tag="a" href="#">
              <i className="mdi mdi-wallet font-size-17 text-muted align-middle me-1"/>
              {props.t("My Wallet")}
            </DropdownItem> */}
          {/* <DropdownItem className="d-flex align-items-center" to="#">
              <i className="mdi mdi-cog font-size-17 text-muted align-middle me-1"></i>
              {props.t("Settings")}<span className="badge bg-success ms-auto">11</span></DropdownItem> */}
          <DropdownItem tag="a" href="/faqs">
            <i className="mdi mdi-frequently-asked-questions font-size-17 text-muted align-middle me-1" />
            FAQ's
          </DropdownItem>
          <DropdownItem tag="a" href="/contact-us">
            <i className="mdi mdi-card-account-mail font-size-17 text-muted align-middle me-1" />
            Contact Us
          </DropdownItem>

          {/* <div className="dropdown-divider" /> */}
          {/* <Button
              onClick={() => {
                dispatch(changeMode("light"))
              }}
            >
              Light
            </Button>
            <Button
              onClick={() => {
                dispatch(changeMode("dark"))
              }}
            >
              Dark
            </Button> */}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ExtrasDropdown.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(ExtrasDropdown)
